import { Routes } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './auth.guard';
import { BlankComponent } from './layouts/blank/blank.component';
import { featureFlagResolver } from '../../../shared/src/lib/resolvers/feature-flag.resolver';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    resolve: {
      featureFlags: featureFlagResolver,
    },
    children: [
      {
        path: '',
        redirectTo: '/starter',
        pathMatch: 'full',
      },

      {
        path: 'starter',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./pages/settings/settings.module').then(
            (m) => m.SettingsModule,
          ),
      },
      {
        path: 'configuration',
        loadChildren: () =>
          import('./pages/configuration/configuration.module').then(
            (m) => m.ConfigurationModule,
          ),
      },
    ],
  },
  {
    path: 'authentication',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule,
          ),
      },
    ],
  },
  {
    path: '',
    redirectTo: '/authentication',
    pathMatch: 'full',
  },
  // {
  //   path: '**',
  //   redirectTo: 'authentication/error',
  // },
];
